/* alif2zee Index theme */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const A = window.A2Z || { routes: {} };
  const R = A.routes;
  const join = (base, path) => (base || '/').replace(/\/$/, '') + path;

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = A.moneyFormat || 'Rs {{amount_no_decimals}}';
    const n = Number(cents) / 100;
    const group = (num, dec, t, d) => {
      const [i, f] = num.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? d + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: group(n, 2, ',', '.'),
      amount_no_decimals: group(n, 0, ',', '.'),
      amount_with_comma_separator: group(n, 2, '.', ','),
      amount_no_decimals_with_comma_separator: group(n, 0, '.', ','),
      amount_with_apostrophe_separator: group(n, 2, "'", '.'),
    }[k] || group(n, 2, ',', '.')));
  }

  /* ---------- overlays ---------- */
  const scrim = $('[data-scrim]');
  let lastFocus = null;
  function drawer() { return $('[data-drawer]'); }
  function openCart() {
    if (document.body.classList.contains('template-cart')) return;
    lastFocus = document.activeElement;
    const d = drawer(); if (!d) return;
    d.classList.add('on'); d.setAttribute('aria-hidden', 'false');
    scrim && scrim.classList.add('on');
    const c = d.querySelector('[data-close]'); c && c.focus();
  }
  function openSearch() {
    lastFocus = document.activeElement;
    const s = $('[data-search]'); if (!s) return;
    s.classList.add('on'); s.setAttribute('aria-hidden', 'false');
    scrim && scrim.classList.add('on');
    setTimeout(() => { const i = $('[data-search-input]'); i && i.focus(); }, 60);
  }
  function closeAll() {
    const d = drawer(); if (d) { d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); }
    const s = $('[data-search]'); if (s) { s.classList.remove('on'); s.setAttribute('aria-hidden', 'true'); }
    $$('[data-size-modal]').forEach(m => m.hidden = true);
    scrim && scrim.classList.remove('on');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  let tt;
  function toast(msg) {
    const t = $('[data-toast]'); if (!t) return;
    $('[data-toast-text]', t).textContent = msg;
    t.classList.add('on'); clearTimeout(tt);
    tt = setTimeout(() => t.classList.remove('on'), 3200);
  }

  /* ---------- cart ---------- */
  async function refreshCart(open) {
    try {
      const res = await fetch(join(R.root, '/?sections=cart-drawer'));
      const json = await res.json();
      const html = json['cart-drawer'];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-drawer]');
        const d = drawer();
        if (fresh && d) d.innerHTML = fresh.innerHTML;
      }
      const cart = await fetch(join(R.cart, '.js')).then(r => r.json());
      $$('[data-cart-count]').forEach(e => e.textContent = cart.item_count);
    } catch (e) { /* fall back to cart page */ if (open) location.href = R.cart; return; }
    if (open) openCart();
  }
  async function changeLine(line, quantity) {
    const box = drawer(); box && box.classList.add('busy');
    try {
      await fetch(join(R.cartChange, '.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
      });
    } finally {
      if (document.body.classList.contains('template-cart')) return location.reload();
      await refreshCart(false);
      box && box.classList.remove('busy');
    }
  }

  /* ---------- global clicks ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-open-cart],[data-open-search],[data-close],[data-line],[data-open-size]');
    if (!t) return;
    if (t.hasAttribute('data-open-cart')) {
      if (document.body.classList.contains('template-cart')) return;
      e.preventDefault(); $('[data-toast]') && $('[data-toast]').classList.remove('on'); openCart();
    } else if (t.hasAttribute('data-open-search')) { e.preventDefault(); openSearch(); }
    else if (t.hasAttribute('data-close')) { e.preventDefault(); closeAll(); }
    else if (t.hasAttribute('data-line')) { e.preventDefault(); changeLine(t.dataset.line, t.dataset.qty); }
    else if (t.hasAttribute('data-open-size')) {
      e.preventDefault(); lastFocus = t;
      const m = t.closest('[data-product]').querySelector('[data-size-modal]');
      if (m) { m.hidden = false; scrim && scrim.classList.add('on'); const c = m.querySelector('[data-close]'); c && c.focus(); }
    }
  });
  scrim && scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
  const hdr = $('[data-header]');
  if (hdr) window.addEventListener('scroll', () => hdr.classList.toggle('sc', window.scrollY > 10), { passive: true });

  /* ---------- predictive search ---------- */
  const qi = $('[data-search-input]'), qr = $('[data-search-results]');
  let qt;
  if (qi && qr) qi.addEventListener('input', () => {
    clearTimeout(qt);
    const q = qi.value.trim();
    if (!q) { qr.innerHTML = ''; return; }
    qt = setTimeout(async () => {
      try {
        const url = join(R.predictive, '.json') + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8';
        const data = await fetch(url).then(r => r.json());
        const items = (data.resources && data.resources.results && data.resources.results.products) || [];
        const esc = s => String(s || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        qr.innerHTML = items.length ? items.map(p => `<a class="sr" href="${esc(p.url)}"><span class="tile">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''}</span><span><b style="font-weight:500">${esc(p.title)}</b></span><span class="mono mute">${esc(p.price ? money(Math.round(parseFloat(p.price) * 100)) : '')}</span></a>`).join('')
          : `<p class="mute">Nothing matches "${esc(q)}". Try a colour like black, maroon or blue.</p>`;
      } catch (e) { qr.innerHTML = ''; }
    }, 180);
  });

  /* ---------- index list ---------- */
  $$('[data-index]').forEach(root => {
    const rows = $$('[data-row]', root);
    const pv = $('[data-preview]', root), img = $('[data-pv-img]', root), title = $('[data-pv-title]', root), code = $('[data-pv-code]', root);
    const empty = $('[data-empty]', root);
    const BLANK = 'data:image/gif;base64,R0lGODlhAQABAAAAACw=';
    // the preview is hidden on phones, so skip its image work there
    const wide = () => pv && getComputedStyle(pv).display !== 'none';
    const load = row => {
      const i = new Image();
      i.sizes = '400px'; if (row.dataset.srcset) i.srcset = row.dataset.srcset; i.src = row.dataset.img;
      return i;
    };
    let current = null;
    function show(row) {
      if (!row || row === current) return;
      current = row;
      rows.forEach(r => r.classList.toggle('on', r === row));
      if (title) title.textContent = row.dataset.title || '';
      if (code) code.textContent = row.dataset.code || '';
      if (pv) pv.href = row.href;
      if (!img || !wide()) return;
      if (!row.dataset.img) { img.removeAttribute('srcset'); img.src = BLANK; img.alt = ''; return; }
      // decode first so the swap doesn't flash; drop it if another row took over meanwhile
      const next = load(row);
      (next.decode ? next.decode() : Promise.resolve()).catch(() => {}).then(() => {
        if (current !== row) return;
        img.sizes = '400px';
        if (row.dataset.srcset) img.srcset = row.dataset.srcset; else img.removeAttribute('srcset');
        img.src = row.dataset.img; img.alt = row.dataset.title || '';
      });
    }
    rows.forEach(r => { r.addEventListener('mouseenter', () => show(r)); r.addEventListener('focus', () => show(r)); });
    // warm the cache for the rest once the page is idle
    if (wide()) (window.requestIdleCallback || (f => setTimeout(f, 1200)))(() => rows.forEach(r => { if (r.dataset.img) load(r); }));
    // the first row's photo is already rendered server-side; just sync the labels
    if (rows[0]) {
      current = rows[0]; current.classList.add('on');
      if (title) title.textContent = current.dataset.title || '';
      if (code) code.textContent = current.dataset.code || '';
    }
    const chips = $$('[data-filter]', root);
    const match = (r, f) => f === 'all' || (' ' + r.dataset.colls + ' ').includes(' ' + f + ' ');
    function filter(f, push) {
      const c = chips.find(x => x.dataset.filter === f); if (!c) return;
      chips.forEach(x => { x.classList.toggle('on', x === c); x.setAttribute('aria-pressed', x === c); });
      let first = null;
      rows.forEach(r => { const ok = match(r, f); r.hidden = !ok; if (ok && !first) first = r; });
      if (empty) empty.hidden = !!first;
      if (pv) pv.hidden = !first;
      show(first);
      // keep the choice in the URL (/#ittefaq) so it can be shared and survives a reload
      if (push) history.replaceState(null, '', f === 'all' ? location.pathname + location.search : '#' + f);
    }
    chips.forEach(c => {
      const n = $('[data-count]', c); if (n) n.textContent = rows.filter(r => match(r, c.dataset.filter)).length;
      c.addEventListener('click', () => filter(c.dataset.filter, true));
    });
    const reset = $('[data-filter-reset]', root); if (reset) reset.addEventListener('click', () => filter('all', true));
    const fromHash = () => { const h = decodeURIComponent(location.hash.slice(1)); if (h) filter(h, false); };
    fromHash();
    window.addEventListener('hashchange', fromHash);
  });

  /* ---------- product ---------- */
  $$('[data-product]').forEach(root => {
    const jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add]', root), hint = $('[data-hint]', root);
    const priceEl = $('[data-price]', root), cmpEl = $('[data-compare]', root), skuEl = $('[data-sku]', root);
    const qty = $('[data-qty]', root);
    const start = product.variants.find(v => String(v.id) === String(idInput && idInput.value)) || product.variants[0];
    const sel = start.options.slice();

    function showMedia(id) {
      if (!id) return;
      const slide = $(`[data-slide="${id}"]`, root); if (!slide) return;
      $$('[data-slide]', root).forEach(s => s.hidden = s !== slide);
      $$('[data-thumb]', root).forEach(t => t.classList.toggle('on', t.dataset.thumb === String(id)));
    }
    $$('[data-thumb]', root).forEach(t => t.addEventListener('click', () => showMedia(t.dataset.thumb)));

    function update(fromClick) {
      const v = product.variants.find(x => x.options.every((o, i) => o === sel[i]));
      $$('[data-opt]', root).forEach(b => {
        const i = Number(b.dataset.opt), val = b.dataset.val;
        b.classList.toggle('on', sel[i] === val);
        const test = sel.slice(); test[i] = val;
        const match = product.variants.find(x => x.options.every((o, k) => o === test[k]));
        b.classList.toggle('na', !match || !match.available);
      });
      $$('[data-opt-label]', root).forEach(l => l.textContent = sel[Number(l.dataset.optLabel)]);
      if (hint) hint.textContent = '';
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (cmpEl) { const on = v.compare_at_price && v.compare_at_price > v.price; cmpEl.hidden = !on; if (on) cmpEl.textContent = money(v.compare_at_price); }
      if (skuEl && v.sku) skuEl.textContent = v.sku;
      addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (v.featured_media) showMedia(v.featured_media.id);
      if (fromClick) { try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {} }
    }
    $$('[data-opt]', root).forEach(b => b.addEventListener('click', () => { sel[Number(b.dataset.opt)] = b.dataset.val; update(true); }));
    update(false);

    const qm = $('[data-qminus]', root), qp = $('[data-qplus]', root);
    qm && qm.addEventListener('click', () => { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    qp && qp.addEventListener('click', () => { qty.value = Math.min(20, (parseInt(qty.value, 10) || 1) + 1); });

    form && form.addEventListener('submit', async e => {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.disabled = true; const label = addBtn.textContent; addBtn.textContent = 'Adding…';
      try {
        const res = await fetch(join(R.cartAdd, '.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await res.json();
        if (!res.ok) { hint.textContent = data.description || data.message || 'Could not add this item. Try again.'; }
        else {
          await refreshCart(false);
          toast(`${data.product_title}${data.variant_title ? ' · ' + data.variant_title.replace(/ \/ /g, ' · ') : ''} added`);
          qty.value = 1;
        }
      } catch (err) { form.submit(); return; }
      addBtn.disabled = false; addBtn.textContent = label;
    });
  });
})();
